export function pwaToastSetter(token: string): void {
	if (localStorage instanceof Storage) {
		localStorage.setItem('clicked_pwa_toast', token);
	}
}
